import React from 'react'
import { UserIcon } from '@heroicons/react/24/outline'

import { PageWrapper } from '../../../shared/components'
import { PageHeader } from '../../../shared/components/PageHeader'
import { useTranslation } from '../../../shared/hooks/useIntractionTranslate'
import { ProfileAccountInformationSection } from '../profile/ProfileAccountInformationSection'
import { ProfileOrganizationSection } from '../profile/ProfileOrganizationSection'
import { ProfileMediaPermissionsSection } from '../profile/ProfileMediaPermissionsSection'
import { ProfileLanguageSection } from '../profile/ProfileLanguageSection'
import { CommunicationPreferencesSection } from '../../../shared/communicationPreferences'
import { ProfileEditAccountModalContainer } from '../profile/ProfileEditAccountModalContainer'
import { ProfileDevToolsSection } from '../profile/devTools/ProfileDevToolsSection'
import { FeatureFlagsStatus } from '../profile/devTools/FeatureFlagsStatus'
import { useDevModeUnlock } from '../profile/hooks/useDevModeUnlock'
import { useProfileEditForm } from '../profile/hooks/useProfileEditForm'

/**
 * Facilitator profile page. Composes the account, organization, media, language,
 * and (in dev mode) dev-tool sections. State is owned by per-concern hooks;
 * this file is wiring only.
 */
export const ProfilePage: React.FC = () => {
  const { t } = useTranslation()
  const { isDevMode, registerClick } = useDevModeUnlock()
  const editForm = useProfileEditForm()

  return (
    <PageWrapper>
      <PageHeader
        badgeText="PROFILE"
        badgeIcon={<UserIcon />}
        title={t('facilitator.profile.title')}
        subtitle={t('facilitator.profile.description')}
      />

      <ProfileAccountInformationSection
        isDevMode={isDevMode}
        onTitleClick={registerClick}
        onEditClick={editForm.open}
      />

      <ProfileOrganizationSection />

      <ProfileMediaPermissionsSection />

      <ProfileLanguageSection />

      <CommunicationPreferencesSection />

      {isDevMode && <ProfileDevToolsSection />}

      {isDevMode && <FeatureFlagsStatus />}

      <ProfileEditAccountModalContainer
        isOpen={editForm.isOpen}
        onClose={editForm.close}
        onSave={editForm.save}
        displayName={editForm.displayName}
        phoneNumber={editForm.phoneNumber}
        onDisplayNameChange={editForm.setDisplayName}
        onPhoneNumberChange={editForm.setPhoneNumber}
        error={editForm.error}
        isSaving={editForm.isSaving}
      />
    </PageWrapper>
  )
}
